import React from 'react';
import PropTypes from 'prop-types';
import { Twitter } from 'grommet-icons/icons/Twitter';
import { LinkedinOption } from 'grommet-icons/icons/LinkedinOption';
import { Facebook } from 'grommet-icons/icons/Facebook';
import styled from 'styled-components';

export const SocialItemsData = [
  {
    slug: 'twitter',
    title: 'Twitter',
    iconComponent: <Twitter size="30px" />,
    url: 'https://twitter.com/PwCUS',
    shareTo: (shareUrl, shareText) => {
      let twitterShareURL = 'http://twitter.com/share?';
      twitterShareURL += `text=${shareText}&`;
      twitterShareURL += `url=${encodeURIComponent(shareUrl)}`;
      const windowOptions =
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600';
      window.open(twitterShareURL, '', windowOptions);
    },
  },
  {
    slug: 'linkedin',
    title: 'LinkedIn',
    iconComponent: <LinkedinOption size="30px" />,
    url: 'https://www.linkedin.com/company/pwc',
    shareTo: (shareUrl) => {
      let linkedInShareURL = `https://www.linkedin.com/sharing/share-offsite/`;
      linkedInShareURL += `?url=${encodeURIComponent(shareUrl)}`;
      const windowOptions =
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600';
      window.open(linkedInShareURL, '', windowOptions);
    },
  },
  {
    slug: 'facebook',
    title: 'Facebook',
    iconComponent: <Facebook size="30px" />,
    url: '',
    shareTo: (shareUrl) => {
      let facebookShareURL = 'https://www.facebook.com/sharer/sharer.php?u=';
      facebookShareURL += encodeURIComponent(shareUrl);
      const windowOptions =
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600';
      window.open(facebookShareURL, '', windowOptions);
    },
  },
];

const StyledSocialIcon = styled.div`
  height: 44px;
  width: 44px;
  justify-content: center;
  align-items: center;
  display: flex;
  svg {
    fill: ${({ variant }) => (variant === 'dark' ? 'white' : 'black')};
    transition: fill 0.3s ease;
  }
  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      svg {
        fill: ${({ theme, variant }) => theme.global.colors.brand};
      }
    }
  }
`;

export const SocialIcon = (props) => {
  const {
    title,
    url,
    shareTo,
    iconComponent,
    variant,
    isShareLink,
    shareText,
    shareUrl,
  } = props;

  const linkProps = {
    href: url,
    title,
    target: '_title',
    rel: 'noreferrer noopener',
  };

  const shareProps = {
    onClick: () => shareTo(shareUrl, shareText),
  };

  const tagType = isShareLink ? 'button' : 'a';
  const elementProps = isShareLink ? shareProps : linkProps;

  return React.createElement(
    StyledSocialIcon,
    { as: tagType, variant, ...elementProps },
    iconComponent,
  );
};

SocialIcon.defaultProps = {
  variant: 'light',
  isShareLink: false,
  shareText: '',
  shareUrl: null,
};
SocialIcon.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  shareTo: PropTypes.func.isRequired,
  iconComponent: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['light', 'dark']),
  isShareLink: PropTypes.bool,
  shareText: PropTypes.string,
  shareUrl: PropTypes.string,
};
